import es_AR from './es-AR'

export default {
  'es-AR': es_AR
}
